import React from 'react';
import { BodySmall } from '@shared/ui/atoms/fonts/Body';
import styled from "styled-components";
import { OfficeEntity } from '@features/desks/services/AdvanceHotDeskingService';

export function ImportantHospitalityNote(props: Props) {
  if (props.office && props.office.hospitalImportantNoteVisible && props.office.hospitalityImportantNote) {
    return (
      <ImportantNoteRow>
        <BodySmall weight={400}>{props.office.hospitalityImportantNote}</BodySmall>
      </ImportantNoteRow>
    )
  }
  return null;
}

interface Props {
  office: OfficeEntity;
}

const ImportantNoteRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 24px;
  p {
    width: 100%;
    padding: 10px 16px;
    border-radius: 12px;
    margin-right: 32px;
    background-color: #E6FCFF;
  }
`
